<template lang="pug">

transition(name="modal")
  .vue-modal-mask
    .modal-con
      .modal
        .modal-header
          a.btn.btn-danger(@click="$emit('closedEnterModal')") Close
        .modal-content
          p Simply fill out the two fields below and hit submit to enter. Your name and phone number will be temporarily stored in our database and a random winner will be returned at the end of the giveaway window.
          .group
            input(v-model="entree" type="text" required)
            span.highlight
            span.bar
            label Name
          .group
            input(v-model="phone" type="tel" required)
            span.highlight
            span.bar
            label Phone Number
          a.btn(@click="enter") Enter
        .modal-header.vue-modal-footer

</template>

<script>
import { db } from '../firebase-config.js'

export default {
  name: 'modal-enter',
  data () {
    return {
      entree: '',
      phone: '',
      scrollPosition: 0
    }
  },
  firebase () {
    return {
      giveawayentries: db.ref('giveawayentries')
    }
  },
  methods: {
    enter () {
      this.$firebaseRefs.giveawayentries.push({
        entree: this.entree || null,
        phone: this.phone || null
      })
      this.$emit('closedEnterModal')
      alert('You are entered! Thank you!')
    }
  },
  mounted () {
    let test = window.pageYOffset
    this.scrollPosition = test
    document.body.style.position = 'fixed'
    document.body.style.top = -test + 'px'
    document.body.style.overflowX = 'hidden'
  },
  destroyed () {
    document.body.style.position = ''
    document.body.style.overflowX = ''
    window.scrollTo(0, this.scrollPosition)
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="stylus">

form
  visibility visible

form
  width 100%
  margin 45px auto

.modal-content
  padding 0 50px

.group
  position relative
  margin 45px 0

textarea
  resize none

input, textarea
  background none
  color muted-color
  font-size 18px
  padding 10px 10px 10px 5px
  display block
  width 100%
  border none
  border-radius 0
  border-bottom 1px solid muted-color
  &:focus
    outline none
  &:focus ~ label, &:valid ~ label
    top -14px
    font-size 12px
    color white
  &:focus ~ .bar:before
    width 100%

input[type="password"]
  letter-spacing 0.3em

label
  color #ffffff50
  font-size 16px
  font-weight normal
  position absolute
  pointer-events none
  left 5px
  top 10px
  transition $trans-time ease all

.bar
  position relative
  display block
  width 100%
  &:before
    content ''
    height 2px
    width 0
    bottom 0px
    position absolute
    background gold
    transition .5s ease all
    left 0%

h4{
  font-size: 50px;
  font-family: lobster;
}
.btn{
  color: white !important;
  font-size: 18px !important;

}
.modal-header{
  display: flex;
  justify-content: flex-end;
}
.notes{
  color: #F1C40F;
  font-weight: bold;
}
.time{
  white-space: nowrap;
}
.detail-item{
      font-size: large;
      border-bottom: 1px dashed white;
      padding: 5px;
      white-space: wrap;
      i{
        color: #F1C40F;
        margin-right: 10px;
      }
    }

.details{
  display: flex;
  @media only screen and (max-width: 500px) {
    display: block;
    width: 100%;
  }
}

.details-left, .details-right{
  display: flex;
  flex-direction: column;
  width: 50%;
  padding: 1em;
  @media only screen and (max-width: 500px) {
    width: 100%;
    border-right: none !important;
    height: auto;
  }
}
.details-left{
  border-right: 1px dashed white;
}
#show-modal {
  margin-top: 100px;
  margin-left: auto;
  margin-right: auto;
}

.vue-modal-mask {
  position: fixed;
  z-index: 9998;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, .5);
  display: table;
  transition: opacity .3s ease;
}

.vue-modal-wrapper {
  display: table-cell;
  vertical-align: middle;
}

.vue-modal-container {
  width: auto;
  max-width: 25%;
  margin: 0px auto;
  padding: 20px 30px;
  border-radius: 2px;
  transition: all .3s ease;
  font-family: Helvetica, Arial, sans-serif;
}

.vue-modal-footer {
  width: 100%
  min-height: 20px;
  position: absolute;
  bottom: 0;
  display: flex;
  align-items: flex-end;
  div{
    display: flex;
    a{
      margin-right: 15px;
    }
  }
  a{
    font-size: medium;
  }
}

.vue-modal-default-button {
  float: right;
}

#unsupported-banner {
  z-index: 999999;
  position: fixed;
  top: 0;
  right: 0;
  left: 0;
  background: #ea3030;
  width: 100%;
  border-bottom: 1px solid #EEEEEE;
  padding: 10px;
  box-sizing: border-box;
  transform: translateY(-150%);
  color: #FFFFFF;
  font-family: "Open Sans", sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  animation: vue-banner-slide-in 0.8s ease forwards;
}


/*
 * The following styles are auto-applied to elements with
 * transition="modal" when their visibility is toggled
 * by Vue.js.
 *
 * You can easily play with the modal transition by editing
 * these styles.
 */

.modal-enter {
  opacity: 0;
}

.modal-leave-active {
  opacity: 0;
}

.modal-enter .modal-container,
.modal-leave-active .modal-container {
  -webkit-transform: scale(1.1);
  transform: scale(1.1);
}


@keyframes vue-banner-slide-in {
  0% {
    transform: translateY(-150%);
  }

  100% {
    transform: translateY(0%);
  }
}
html{
  overflow: hidden !important;
}

.overlayish {
  position: fixed;
  z-index: 9998;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0,
  0, 0, .5);
}

</style>
